import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["NuqsAdapter"] */ "/app/node_modules/nuqs/dist/adapters/next/app.js");
;
import(/* webpackMode: "eager", webpackExports: ["QueryClientProvider"] */ "/app/scribe-frontend/app/_providers/QueryClientProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/scribe-frontend/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/app/scribe-frontend/styles/Fonts.css");
;
import(/* webpackMode: "eager" */ "/app/packages/stylus-ui/global.css");
